import { InjectionToken } from '@angular/core';

export interface GalaxyPageOptions {
  showToggle: boolean;
  toggleNav: () => unknown;
  mobileMaxWidth?: number | null;
  navToggleTooltip?: string;
}
export const GALAXY_PAGE_OPTIONS = new InjectionToken<GalaxyPageOptions>(
  '[Galaxy Page]: Configuration for component options',
);
